import * as React from "react";
import type { SVGProps } from "react";
const SvgParallelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="parallel_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M506.07 710.4 346.367 870.059a42.667 42.667 0 1 0 60.33 60.373L566.4 770.731A149.333 149.333 0 0 0 768.81 568.32l156.033-156.032a42.667 42.667 0 0 0-60.331-60.33L708.48 507.946a149.333 149.333 0 0 0-202.41 202.41zM336.596 559.787 559.104 337.28a149.333 149.333 0 1 0-57.77-62.933L273.108 502.528a149.333 149.333 0 1 0 63.531 57.259zM145.024 637.44a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm490.667-492.373a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-62.251 494.25a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
    />
  </svg>
);
export default SvgParallelIcon;
